module.exports = __webpack_public_path__ + "img/benefit-abcd.c3e5fae5.svg";